import { Alert, AlertType } from '@design/components/alert/Alert';
import {
  ToastPosition,
  useToasts,
} from '@terminal/stores/use-toasts/useToasts';
import {
  resolveWebSearchConfig,
  WebSearch,
  WebSearchToolsConfig,
} from '@terminal/views/alfred/research/services/conversations-service';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const useResolveWebSearch = () => {
  const { t } = useTranslation(['chat']);
  const showToast = useToasts(state => state.showToast);
  const removeToast = useToasts(state => state.removeToast);
  const [isResolving, setIsResolving] = useState(false);

  const resolve = async (
    webSearch: WebSearch
  ): Promise<WebSearchToolsConfig | null> => {
    setIsResolving(true);
    try {
      return await resolveWebSearchConfig(webSearch);
    } catch {
      const toastId = `task-toast-error-${Date.now()}`;
      showToast({
        id: toastId,
        position: ToastPosition.TopRight,
        content: (
          <Alert
            type={AlertType.Error}
            title={t('chat:scheduledQuerySettings.saveErrorTitle')}
            message={t('chat:scheduledQuerySettings.saveErrorMessage')}
            onClose={() => removeToast(toastId)}
          />
        ),
      });
      return null;
    } finally {
      setIsResolving(false);
    }
  };

  return { resolve, isResolving };
};
